<template>
  <el-tabs type="border-card" v-model="processProduceAchievement">
    <el-tab-pane name="actualProduction" label="生产实绩">
      <ProcessActualProduction v-if="processProduceAchievement == 'actualProduction'"/>
    </el-tab-pane>
    <el-tab-pane name="productive" label="生产性" >
      <ProcessProductive v-if="processProduceAchievement == 'productive'"/>
    </el-tab-pane>
  </el-tabs>

</template>

<script>

import ProcessProductive from "@/views/applications/bus/make_schedule/ProcessProductive";
import ProcessActualProduction from "@/views/applications/bus/make_schedule/ProcessActualProduction";
export default {
  name: "ProcessProduceAchievement",
  components:{ProcessActualProduction, ProcessProductive},
  data(){
    return{
      processProduceAchievement:'actualProduction',
    }
  }
}
</script>

<style scoped>
.el-table :deep(.cell) {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
  text-align: center;
}
</style>